<script lang="ts" setup>
import { useHead } from '#imports';
import { message } from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import BackTopButton from '~/components/BackTopButton.vue';
import ImChatStudent from '~/pages/components/im/ImChatStudent.vue';
import BindphoneModal from '~/pages/modals/BindphoneModal.vue';
import LoginModal from '~/pages/modals/LoginModal.vue';
import NewUserAddTeacherModal from '~/pages/modals/NewUserAddTeacherModal.vue';
import ProfileCompleteModal from '~/pages/modals/ProfileCompleteModal.vue';
import ProgramLevelModal from '~/pages/modals/ProgramLevelModal.vue';
import SelectZoneModal from '~/pages/modals/SelectZoneModal.vue';
import AppNotification from './components/AppNotification.vue';

// import LevelUpgradeModal from './components/LevelUpgradeModal/LevelUpgradeModal.vue';
// import LevelRewardModal from './components/LevelRewardModal/LevelRewardModal.vue';
// import CursorTrail from './components/CursorTrail.vue';


const themeConfig = {
  token: {
    borderRadius: 4,
    wireframe: true,
    colorPrimary: '#6850ff',
    colorWarning: '#ff7d00',
    colorSuccess: '#00b42a',
    colorError: '#f53f3f',
    colorInfo: '#1677ff',
    colorBgLayout: '#FAFAFA',
    controlItemBgActive: '#6850ff',
  },
};

message.config({
  maxCount: 1,
});

useHead({
  bodyAttrs: {
    class: 'fe-oj-ninja',
  },
});
</script>

<template>
  <a-style-provider hash-priority="high">
    <a-config-provider :theme="themeConfig" :locale="zhCN">
      <NuxtLayout>
        <NuxtPage />
        <LoginModal />
        <BindphoneModal />
        <ProfileCompleteModal />
        <ProgramLevelModal />
        <NewUserAddTeacherModal />
        <SelectZoneModal />
        <BackTopButton />
        <AppNotification />
        <ImChatStudent />
      </NuxtLayout>
    </a-config-provider>
  </a-style-provider>
</template>
